export enum Constant {
  Uploads = "Uploads",
}
export default Constant;
